// addJob.js
'use strict';
import { v4 as uuidv4 } from 'uuid';

import { MERGE_OPERATION_DATA, ADD_LIST_ITEMS } from '../ActionTypes.js';

/**
 * Add job
 * @kind action
 * @param {string} {jobType} - job type.
 * @param {array} {selectPath} - select path.
 * @param {object} {payload} - action payload.
 * @return {Promise} Action promise.
 */
const addJob =
  ({ jobType, selectPath, payload }) =>
  async dispatch => {
    const jobId = uuidv4();
    dispatch({
      type: ADD_LIST_ITEMS,
      payload: {
        selectPath,
        itemIds: [jobId],
      },
    });
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['jobs'],
        data: {
          [jobId]: {
            ...payload,
            jobType,
          },
        },
      },
    });
  };

export default addJob;
